import { CLIENTS } from "../actions/utilities";

const INITIAL_STATE = {
  getClientLoading: false,
  getClientSuccess: false,
  getClientFailure: false,
  getClientError: null,
  addClientLoading: false,
  addClientSuccess: false,
  addClientFailure: false,
  addClientError: null,
  editClientLoading: false,
  editClientSuccess: false,
  editClientFailure: false,
  editClientError: null,
  deleteClientLoading: false,
  deleteClientSuccess: false,
  deleteClientFailure: false,
  deleteClientError: null,
  clientList: [],
};

export const clientReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CLIENTS.GET_CLIENT_REQUEST:
      return {
        ...state,
        getClientLoading: true,
        getClientSuccess: false,
        getClientFailure: false,
        getClientError: null,
      };
    case CLIENTS.GET_CLIENT_SUCCESS:
      let list = [];
      if (action.payload?.length > 0) {
        list = action.payload;
      }
      return {
        ...state,
        getClientLoading: false,
        getClientSuccess: true,
        getClientFailure: false,
        getClientError: null,
        clientList: list,
      };
    case CLIENTS.GET_CLIENT_FAILURE:
      return {
        ...state,
        getClientLoading: false,
        getClientSuccess: false,
        getClientFailure: true,
        getClientError: action.payload,
      };
    case CLIENTS.ADD_CLIENT_REQUEST:
      return {
        ...state,
        addClientLoading: true,
        addClientSuccess: false,
        addClientFailure: false,
        addClientError: null,
      };
    case CLIENTS.ADD_CLIENT_SUCCESS:
      let client = [];
      let clientList = state.clientList;
      if (action.payload === null) {
        client = action.payload;
      } else {
        clientList?.unshift(action.payload);
      }

      return {
        ...state,
        addClientLoading: false,
        addClientSuccess: true,
        addClientFailure: false,
        addClientError: null,
        clientList: client === [] ? [] : clientList,
      };
    case CLIENTS.ADD_CLIENT_FAILURE:
      return {
        ...state,
        addClientLoading: false,
        addClientSuccess: false,
        addClientFailure: false,
        addClientError: action.payload,
      };
    case CLIENTS.EDIT_CLIENT_REQUEST:
      return {
        ...state,
        editClientLoading: true,
        editClientSuccess: false,
        editClientFailure: false,
        editClientError: null,
      };
    case CLIENTS.EDIT_CLIENT_SUCCESS:
      let client_ = state.clientList;
      for (var i = 0; i < client_.length; i++) {
        if (client_[i].userId === action.payload.userId) {
          client_[i] = action.payload;
        }
      }
      return {
        ...state,
        editClientLoading: false,
        editClientSuccess: true,
        editClientFailure: false,
        editClientError: null,
        clientList: client_,
      };
    case CLIENTS.EDIT_CLIENT_FAILURE:
      return {
        ...state,
        editClientLoading: false,
        editClientSuccess: false,
        editClientFailure: true,
        editClientError: action.payload,
      };
    case CLIENTS.REMOVE_CLIENT_REQUEST:
      return {
        ...state,
        deleteClientLoading: true,
        deleteClientSuccess: false,
        deleteClientFailure: false,
        deleteClientError: null,
      };
    case CLIENTS.REMOVE_CLIENT_SUCCESS:
      let client_list = state.clientList;
      for (var i = 0; i < client_list.length; i++) {
        if (client_list[i].userId === action.payload) {
          client_list.splice(i, 1);
        }
      }
      return {
        ...state,
        deleteClientLoading: false,
        deleteClientSuccess: true,
        deleteClientFailure: false,
        deleteClientError: null,
        clientList: client_list,
      };
    case CLIENTS.REMOVE_CLIENT_FAILURE:
      return {
        ...state,
        deleteClientLoading: false,
        deleteClientSuccess: false,
        deleteClientFailure: true,
        deleteClientError: action.payload,
      };
    default:
      return state;
  }
};
